import { gql } from '@apollo/client';

export const GET_EXCHANGE_READY_FILES = gql`
  query PDF_SERVICE_getExchangeReadyFiles($domainId: ID!, $setAsSent: Boolean = false) {
    getExchangeReadyFiles(domainId: $domainId, setAsSent: $setAsSent) {
      id
      policyId
      pdfLocation
      zipLocation
      creationDate
    }
  }
`;
